import Config from '../../Config';

const config = new Config();

const clientHubBaseUrl = config.hubBaseUrl.replace(/\?optin=true$/, '');
const clientHubRolloverUrl = `${clientHubBaseUrl}/dashboard#transfers/rollover/disclosure`;

export const inlineButtons = Object.freeze({
  newDomesticCustomerOptions: ['linkBankAccount', 'wireTransfer'],
  existingDomesticCustomerOptions: ['onlineTransfer', 'linkBankAccount', 'wireTransfer'],
  newInternationalCustomerOptions: ['wireTransfer', 'linkBankAccount'],
  existingInternationalCustomerOptions: ['onlineTransfer', 'wireTransfer', 'linkBankAccount'],

  newDomesticIraEquitiesCustomerOptions: ['rollover401k', 'depositCash', 'transferAccount'],
  existingDomesticIraEquitiesCustomerOptions: ['rollover401k', 'depositCash', 'transferAccount'],
  newDomesticNonIraEquitiesCustomerOptions: ['depositCash', 'transferAccount'],
  existingDomesticNonIraEquitiesCustomerOptions: ['depositCash', 'transferAccount'],
  newDomesticNonIraJustFuturesCustomerOptions: ['linkBankAccount', 'wireTransfer'],

  domesticAdditionalOptions: ['checkDeposit'],
  internationalAdditionalOptions: ['checkDeposit', 'transferService'],

  newDomesticIraEquitiesIntermediateOptions: ['linkBankAccount', 'wireTransfer'],
  existingDomesticIraEquitiesIntermediateOptions: ['onlineTransfer', 'linkBankAccount', 'wireTransfer'],
  newDomesticNonIraEquitiesIntermediateOptions: ['linkBankAccount', 'wireTransfer'],
  existingDomesticNonIraEquitiesIntermediateOptions: ['onlineTransfer', 'linkBankAccount', 'wireTransfer'],

  depositCryptoOptions: 'depositCrypto',
  inlineButtons: ['checkDeposit'],
  equitiesOnlyOptions: ['transferAccount'],
});

export const InlineFundingButtons = {
  linkBankAccount:
  {
    id: 'link_bank_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'link bank account',
    url: `${config.fundingUrl}/external/add-automatic`,
    isRedirected: true,
  },
  wireTransfer: {
    id: 'wire_transfer_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'wire transfer',
    url: `${config.fundingUrl}/transfers/wire/in`,
    isRedirected: true,
  },
  onlineTransfer: {
    id: 'online_transfer_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'online transfer',
    url: `${config.fundingUrl}/transfers`,
    isRedirected: true,
  },
  depositCrypto: {
    id: 'deposit_crypto_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'Deposit Crypto',
    isRedirected: false,
  },
  transferAccount: {
    id: 'transfer_account_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'Transfer Account',
    isRedirected: false,
  },
  rollover401k: {
    id: 'rollover_401k_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'Rollover 401(K)',
    url: clientHubRolloverUrl,
    isRedirected: true,
    isExternalRedirect: true,
  },
  checkDeposit: {
    id: 'check_deposit_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'Check Deposit',
    url: `${config.fundingUrl}/transfers/check/in`,
    isRedirected: true,
  },
  transferService: {
    id: 'transfer_service_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'Transfer Service',
    isRedirected: false,
  },
  depositCash: {
    id: 'deposit_cash_btn',
    className: 'btn inline-btn do_capitalize',
    label: 'Deposit Cash',
    isRedirected: false,
  },
};
